import { Component, OnInit, ViewChild } from '@angular/core';
import { CatalogService, FormsService } from 'src/app/services/service.index';
import { especialidad } from './../../models/medico.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GridComponent } from 'src/app/shared/components/grid.component';
import { catalog } from 'src/app/models/catalog.model';
import { FormGroup } from '@angular/forms';
@Component({
  selector: 'app-areas',
  templateUrl: './areas.component.html',
  styles: []
})
export class AreasComponent implements OnInit {
  @ViewChild("modal", { static: true }) modal;
  @ViewChild(GridComponent, { static: true }) mygrid: GridComponent;
  
  rowData: any;
  columnDefs = [
    { headerName: "Nombre", field: "nombre"},
    { headerName: "Código", field: "codigo" },
    { headerName: "Descripción", field: "descripcion" }
  ];
  _area:catalog = new catalog({});
  constructor(public _cat: CatalogService, private modalService: NgbModal, public _frm: FormsService) { }

  ngOnInit() {
    this._cat.get_catalog("area", true).subscribe(data => this.rowData = data, error => console.log(error));
  }

  
  option_selector(button: string) {
    console.log(button);
    
    switch (button) {
      case "create": {
        this._area = new catalog({});
        this.modalService.open(this.modal, { size: 'lg' });
        break;
      }
      case "update": {
          this._frm.get_rows_selected(this.mygrid, false, (selecteds) => {
          this._area = selecteds[0];
          this.modalService.open(this.modal, { size: 'lg' })
        });
        break;
      }
      case "delete": {
        this._frm.get_rows_selected(this.mygrid, false, (selecteds) => {
          this._area = selecteds[0];
          console.log(this._area.id)
          this._frm.show_warning('Borrar área', 'Estas seguro de eliminar el área [' + this._area.nombre + ']. Una vez eliminado no podra recuperarse.', () => this.delete_area(this._area.id));
        });
        break;
      }
    }
  }

  delete_area(id:number) {
    this._cat.delete_catalog("area","area",id).subscribe(
      (res: any) => {this._frm.toast_alert("Area eliminada exitosamente", "Borrar Area ", "success");
      this.modalService.dismissAll(null);
      this._cat.get_catalog("area",true).subscribe(data => this.rowData = data, error => console.log(error));
    },
      error => { console.log(error); this._frm.toast_alert("El Tipo consulta no pudo ser actualizado correctamente. Error: " + error.error.message, "Borrar Tipo consulta", "error") }
    );
  }
  save_area(form: FormGroup) {
    this._frm.save_module(form, "id", () => {
      this._cat.insert_catalog(form.value).subscribe(
        (res: any) =>
        { this._frm.toast_alert("Área creada exitosamente", "Nueva Area", "success");
          this.modalService.dismissAll(null);
          this._cat.get_catalog("area", true).subscribe(data => this.rowData = data, error => console.log(error));
        },
        error => this._frm.toast_alert("El area no pudo ser creado correctamente. Error: " + error.error.message, "Nueva Area", "error")
      );
      
    }, () => {
       this._cat.update_catalog(form.value).subscribe(
        (res: any) =>
         {this._frm.toast_alert("Area actualizada exitosamente", "Actualizar Area", "success");
         this.modalService.dismissAll(null); 
         this._cat.get_catalog("area",true).subscribe(data => this.rowData = data, error => console.log(error));     
          },
         error => {
           this._frm.toast_alert("El area no pudo ser actualizado correctamente. Error: " + error.error.message, "Actualizar Area", "error");
         }
       );
    });

  }



}
